// extracted by mini-css-extract-plugin
export default {"FAQTemplate":"FAQTemplate_FAQTemplate__-aZQI"};